import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import type { Contrato, Mensalidade, Cidade, Categoria, ParceiroResult } from "./clienteService";

const urlBase = `${config.urlApi}/Empresa`;

const urls = {
  loginExterno: `${urlBase}/LoginExterno`,
  obterDados: `${urlBase}/Dados`,
  obterParceiros: `${urlBase}/Parceiros`,
  obterCidades: `${urlBase}/Cidades`,
  alterarSenha: `${urlBase}/AlterarSenha`,
}

function getToken(): string {

  const userJson = localStorage.getItem('empresaUser');
  if (!userJson) {
    return "";
  }

  const user = JSON.parse(userJson) as EmpresaLoginResult;
  const accessToken = user.accessToken;

  if (accessToken != null) {
    return `Bearer ${accessToken}`;
  } else {
    return "";
  }
}

export const loginExterno = (param: EmpresaLoginExterno): Promise<EmpresaLoginResult> => {
  return new Promise((resolve, reject) => {

    axios
      .post(urls.loginExterno, param)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao realizar login externo")));
  });
};

export const obterDados = (): Promise<DadosEmpresa> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obterDados)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export const obterParceiros = (filtros: EmpresaParceirosFiltros): Promise<ParceiroResult> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.obterParceiros, filtros)
      .then((r) => {
        const retorno = r.data as ParceiroResult;
        retorno.dados.forEach(p => {
          if (p.arquivo != null && p.arquivo != "") {
            p.arquivo = `${config.urlApi}/parceiros/${p.parceiroId}/${p.arquivo}`;
          }
        });

        return resolve(retorno);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export const obterCidades = (): Promise<Cidade[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.obterCidades)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export const alterarSenha = (senhaAtual: string, senhaNova: string, senhaNovaConfirmacao: string): Promise<{ mensagem: string }> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios
      .post(urls.alterarSenha, { senhaAtual, senhaNova, senhaNovaConfirmacao })
      .then((r) => resolve(r.data))
      .catch(error => reject(new ApiException(error || "Falha ao alterar senha")));
  });
};

export interface EmpresaLoginExterno {
  empresaId: number | null;
  senha: string;
}

export interface EmpresaLoginResult {
  userName: string;
  empresaId: number;
  nome: string;
  accessToken: string;
  refreshToken: unknown;
}

export interface EmpresaParceirosFiltros {
  pesquisa: string;
  parceiroId: number | null;
  cidadeId: number | null;
  categoriaId: number | null;
  paginaAtual: number;
  tamanhoPagina: number;
}

export interface DadosEmpresa {
  empresa: Empresa;
  funcionarios: FuncionarioDto[];
  contratos: Contrato[];
  mensalidades: Mensalidade[];
  categorias: Categoria[];
}

export interface Empresa {
  empresaId: number;
  usuarioId: number;
  ativo: boolean;
  nome: string;
  responsavel: string | null;
  cnpj: string | null;
  ie: string | null;
  im: string | null;
  telefone: string | null;
  celular: string | null;
  logradouro: string | null;
  numero: string | null;
  bairro: string | null;
  cidadeId: number | null;
  cep: string | null;
  complemento: string | null;
  email: string | null;
  observacoes: string | null;
  cidade: Cidade | null;
}

export interface FuncionarioDto {
  empresaId: number;
  clienteId: number;
  nome: string;
  cpf: string;
  dataNascimento: string | null;
  celular: string;
  planoNome: string;
  valor: number;
}
